import WMTSLayer from '@arcgis/core/layers/WMTSLayer';
import { GISServiceTypes } from '../gisServicesTypes';
import { LayerLoader, ensureLoadedLayerArray } from './LayerLoader';

export const wmtsLayerLoader: LayerLoader = {
  shouldUseLoader(service) {
    return service.service_type == GISServiceTypes.wmts;
  },

  async load(service) {
    const layer = new WMTSLayer({
      url: service.gis_service_url,
      id: service.gisLayerID,
      activeLayer: {
        id: service?.attributes?.sublayers?.[0] || '',
      },
      visible: false,
    });

    await layer.load();

    return ensureLoadedLayerArray(layer);
  },
};
